<template>
	<div>
		<div class="step-block">
			<div class="step-box">
				<div>
					Choose entry time
				</div>
				<div class="step-img">
					<img src="../../../static/step_process.png" alt="">
				</div>
			</div>
			<div class="step-line" :style="{borderBottom: step >= 2 ? '1px solid #264EA7' : '1px solid #B6B6B6'}">

			</div>
			<div class="step-box">
				<div :style="{color: step >= 2 ? '#264EA7' : '#B6B6B6'}">
					Input information
				</div>
				<div class="step-img">
					<img :src="step >= 2 ? '../../../static/step_process.png' : '../../../static/step_wait.png'" alt="">
				</div>
			</div>
			<div class="step-line" :style="{borderBottom: step >= 3 ? '1px solid #264EA7' : '1px solid #B6B6B6'}">

			</div>
			<div class="step-box">
				<div :style="{color: step >= 3 ? '#264EA7' : '#B6B6B6'}">
					Complete
				</div>
				<div class="step-img">
					<img :src="step >= 3 ? '../../../static/step_process.png' : '../../../static/step_wait.png'" alt="">
				</div>
			</div>
		</div>
		<!-- 选择时间 -->
		<div class="step1" v-if="step === 1">
			<div class="top">
				<div class="top-choose">
					<div class="choose" @click="chooseIndex = 0" :style="{color: chooseIndex === 0 ? '#8a8a8a' : '', borderBottom: chooseIndex === 0 ? '3px solid #4978C7' : ''}">
						Make an appointment
					</div>
					<div class="choose" @click="chooseIndex = 1" :style="{color: chooseIndex === 1 ? '#8a8a8a' : '', borderBottom: chooseIndex === 1 ? '3px solid #4978C7' : ''}">
						Booking information
					</div>
				</div>
			</div>
			<div class="choose-1" v-if="chooseIndex === 0">
				<div class="month">
					{{month}}
				</div>
				<div class="calendar">
					<div class="calendar-top">
						<div class="calendar-top-box">
							<div>
								SUN
							</div>
							<div>
								日
							</div>
						</div>
						<div class="calendar-top-box">
							<div>
								MON
							</div>
							<div>
								一
							</div>
						</div>
						<div class="calendar-top-box">
							<div>
								TUE
							</div>
							<div>
								二
							</div>
						</div>
						<div class="calendar-top-box">
							<div>
								WED
							</div>
							<div>
								三
							</div>
						</div>
						<div class="calendar-top-box">
							<div>
								THU
							</div>
							<div>
								四
							</div>
						</div>
						<div class="calendar-top-box">
							<div>
								FRI
							</div>
							<div>
								五
							</div>
						</div>
						<div class="calendar-top-box">
							<div>
								SAT
							</div>
							<div>
								六
							</div>
						</div>
					</div>
					<div class="calendar-main" v-if="yuYueType == 'geren'">
						<div class="calendar-box" v-for="(item, index) in dateList" :key="index" @click="selectDate(item)">
							<div v-if="item.is_show === true">
								<div v-if="item.open === true" class="open-date">
									<div class="open-date-top">
										{{item.date}}
									</div>
									<div class="open-date-bottom">
										left{{'  ' + item.left_tickets_num}}
									</div>
								</div>
								<div v-else-if="item.open === false" class="close-date">
									<div class="close-date-left">
										{{item.date}}
									</div>
									<div class="close-date-right">
										Closed
									</div>
								</div>
							</div>
							<div v-else>

							</div>
						</div>

					</div>
					<div class="calendar-main" v-else>
						<div class="calendar-box" v-for="(item, index) in tdDateList" :key="index" @click="selectDate(item)">
							<div v-if="item.is_show === true">
								<div v-if="item.open === true" class="open-date">
									<!-- <div class="open-date-top">
										{{item.date}}
									</div>
									<div class="open-date-bottom">
										余{{item.left_tickets_num}}
									</div> -->
									<div style="font-size: 20px; line-height: 55px; text-align: center;" v-if="item.left_tickets_num > 0">
										{{item.date}}
									</div>
									<div style="font-size: 20px; line-height: 55px; text-align: center; color: #96CCDF;" v-else>
										{{item.date}}
									</div>
								</div>
								<div v-else-if="item.open === false" class="close-date">
									<div class="close-date-left">
										{{item.date}}
									</div>
									<div class="close-date-right">
										Closed
									</div>
								</div>
							</div>
							<div v-else>

							</div>
						</div>
					</div>
				</div>
				<div class="yuyue-type">
					<div class="yuyue-box" @click="yuYueType = 'geren'" :style="{color: yuYueType === 'geren' ? '#FFFFFF' : '#264EA7', backgroundColor: yuYueType === 'geren' ? '#264EA7' : '', border:  yuYueType === 'geren' ? '' : '1px solid #264EA7'}">
						Personal appointment
					</div>
					<div class="yuyue-box" @click="yuYueType = 'tuandui'" :style="{color: yuYueType === 'tuandui' ? '#FFFFFF' : '#264EA7', backgroundColor: yuYueType === 'tuandui' ? '#264EA7' : '', border:  yuYueType === 'tuandui' ? '' : '1px solid #264EA7'}">
						Team appointment
					</div>
				</div>
			</div>
			<div class="inner-content" v-if="chooseIndex === 1" v-html="yuYueType === 'geren' ? needReadGr : needReadTd" style="margin-top: 20px;">

			</div>
		</div>
		<div class="step2" v-if="step === 2">
			<div class="geren-block" v-if="yuYueType === 'geren'">
				<div class="geren-date">
					DATA SELECTED: <span style="margin-left: 5px; color: #5EB5C0;">{{chooseDate.allDate}}</span>
				</div>
				<RadioGroup v-model="mpType" class="mp-type">
					<Radio :label="index" v-for="(item, index) in ticketList" :key="index">{{item.type === 'AM' ? 'The morning of the visiting tickets' : 'The afternoon of the visiting tickets'}} {{'  '}} {{item.timeInterval}} {{'  (left' + item.ticNum + '人)'}}</Radio>
				</RadioGroup>
				<Row class="self-user-list-top" :gutter="20" >
					<Col span="4" style="text-align: center;">
						Contact name
					</Col>
					<Col span="4" style="text-align: center;">
						Contact mobile number
					</Col>
					<Col span="6" style="text-align: center;">
						Verification Code
					</Col>
				</Row>
				<Row class="self-user-item" :gutter="20" >
					<Col span="4" style="text-align: center;">
						<Input v-model="liaisonUser" type="text"></Input>
					</Col>
					<Col span="4" style="text-align: center;">
						<Input v-model="telephone" maxlength="11" type="text"></Input>
					</Col>
					<Col span="6" style="text-align: center;display: flex;align-items: center;">
						<Input v-model="validateCode" maxlength="6" type="text"></Input>
						<img v-if="imgData" :src="imgData" alt="" style="width: 90px; height: 30px; margin-left: 20px; cursor: pointer;" @click="getImgData"></img>
					</Col>
				</Row>
				<Row class="self-user-list-top" :gutter="20" >
					<Col span="2" style="text-align: center;">
						Serial
					</Col>
					<Col span="5" style="text-align: center;">
						Ticket name
					</Col>
					<Col span="5" style="text-align: center;">
						ID Type
					</Col>
					<Col span="6" style="text-align: center;">
						ID Number
					</Col>
					<Col span="5" style="text-align: center;">
						Name
					</Col>
				</Row>
				<Row class="self-user-item" v-for="(item, index) in selfUserList" :gutter="20" :key="index">
					<Col span="2" style="text-align: center;">
						{{index + 1}}
					</Col>
					<Col span="5" style="text-align: center;">
						<!-- <Select v-model="item.ticket_type">
							<Option v-for="(item1, index1) in yearType" :value="index1" :key="index1">{{ `参观门票` + item1.name }}</Option>
						</Select> -->
						Admission ticket
					</Col>
					<Col span="5">
						<Select v-model="item.card_type">
							<Option v-for="(item1, index1) in zjType" :value="item1.value" :key="item1.value">{{ item1.label }}</Option>
						</Select>
					</Col>
					<Col span="6">
						<Input v-model="item.card_no"></Input>
					</Col>
					<Col span="5">
						<Input v-model="item.name"></Input>
					</Col>
					<Col span="1" style="text-align: center;">
						<div @click="addSelf" style="margin-top: 16px; width: 20px; height: 20px; line-height: 20px; color: #127EBD; border: 1px solid #127EBD; font-size: 16px; cursor: pointer;" v-if="index === 0">
							+
						</div>
						<div @click="removeSelf(index)" style="margin-top: 16px; width: 20px; height: 20px; line-height: 20px; color: #127EBD; border: 1px solid #127EBD; font-size: 16px; cursor: pointer;" v-else>
							-
						</div>
					</Col>
				</Row>
				<div class="tishi">
					<div style="margin-left: 30px;">
						Warm prompt:
					</div>
					<div style="text-align: left; margin-left: 10px;">
						<div>
							1. Visitors who fill in the second-generation ID card can enter the museum directly with the original ID card.
						</div>
						<div>
							2. Visitors who fill in Hong Kong, Macao and Taiwan ID cards or passports should bring the original id cards to the ticket window to exchange for tickets, and then enter the museum with the tickets.
						</div>
					</div>
				</div>
				<div style="width: 90%; text-align: right; font-size: 13px;">
					<span style="color: #298BC3;">Order amount:</span> <span style="margin-left: 10px;">Free</span>
				</div>
				<div class="button-list">
					<Button size="large" style="background-color: #0E72E1; color: #FFFFFF; font-size: 12px; width: 100px;" @click="backStep1">BACK</Button>
					<Button size="large" style="margin-left: 40px; background-color: #127EBD; color: #FFFFFF; font-size: 12px; width: 180px;" @click="commitSelf">PERSONAL APPOINTMENT</Button>
				</div>
			</div>
			<div class="tuandui-block" v-if="yuYueType === 'tuandui'">
				<div class="tuandui-date">
					DATA SELECTED: <span style="margin-left: 5px; color: #5EB5C0;">{{chooseDate.allDate}}</span>
				</div>
				<RadioGroup v-model="mpType" class="mp-type">
					<Radio :label="index" v-for="(item, index) in ticketList" :key="index" style="margin-right: 20px;">{{item.type === 'AM' ? 'The morning of the visiting tickets' : 'The afternoon of the visiting tickets'}} {{'  '}} {{item.timeInterval}}</Radio>
				</RadioGroup>
				<div class="block">
					Fill in the information
				</div>
				<Row :gutter="10" class="tdzl-block">
					<Col span="8">
						<Row style="display: flex;">
							Leader：
							<Input v-model="tuanduiObj.name" style="width: 60%; line-height: 70px;"></Input>
						</Row>
					</Col>
					<Col span="8">
						<Row style="display: flex;">
							Mobile number：
							<Input v-model="tuanduiObj.telephone" style="width: 65%; line-height: 70px;"></Input>
						</Row>
					</Col>
					<Col span="8">
						<Row style="display: flex;">
							Team name：
							<Input v-model="tuanduiObj.teamname" style="width: 60%; line-height: 70px;"></Input>
						</Row>
					</Col>
				</Row>
				<div class="block">
					Upload certificate attachment
				</div>
				<Row>
					<Col span="12" class="upload-block">
						<div style="width: 150px;">
							Reservation form：
						</div>
						<div class="upload-box">
							<div class="upload-box-top" :style="{backgroundColor: tuanduiObj.teamOrderLetter ? '#FFFFFF' : '#D3D3D3'}">
								<img style="width: 100%; height: 100%;" v-if="tuanduiObj.teamOrderLetter" :src="$imgUrl + tuanduiObj.teamOrderLetter" alt="">
							</div>

							<div class="upload-box-bottom">
								<a href="../../../static/团体参观预约表.docx" download="团体参观预约表模板.docx">Download template</a>
							</div>
						</div>
						<Upload
							class="upload-button"
							ref="img_ref"
							:action="$baseUrl + '/sys/accessory/uploadFile'"
							:on-success="successUploadTeamOrderLetter"
							:max-size="10240"
							name="uploadFile">
							Select
						</Upload>
						<span style="margin-left: 10px; line-height: 30px; text-align: left;">(Please upload JPEG, PNG file)</span>
					</Col>
					<Col span="12" class="upload-block">
						<div style="width: 150px;">
							Visit the letter：
						</div>
						<div class="upload-box">
							<div class="upload-box-top" :style="{backgroundColor: tuanduiObj.teamVisitLetter ? '#FFFFFF' : '#D3D3D3'}">
								<img style="width: 100%; height: 100%;" v-if="tuanduiObj.teamVisitLetter" :src="$imgUrl + tuanduiObj.teamVisitLetter" alt="">
							</div>

							<div class="upload-box-bottom">
								<a href="../../../static/团体参观函.docx" download="团体参观函模板.docx">Download template</a>
							</div>
						</div>
						<Upload
							class="upload-button"
							ref="img_ref"
							:action="$baseUrl + '/sys/accessory/uploadFile'"
							:on-success="successUploadTeamVisitLetter"
							:max-size="10240"
							name="uploadFile">
							Select
						</Upload>
						<span style="margin-left: 10px; line-height: 30px; text-align: left;">(Please upload JPEG, PNG file)</span>
					</Col>
				</Row>
				<Row style="margin-top: 20px;">
					<Col span="12" class="upload-block">
						<div style="width: 150px;">
							Safety commitment：
						</div>
						<div class="upload-box">
							<div class="upload-box-top" :style="{backgroundColor: tuanduiObj.letter ? '#FFFFFF' : '#D3D3D3'}">
								<img style="width: 100%; height: 100%;" v-if="tuanduiObj.letter" :src="$imgUrl + tuanduiObj.letter" alt="">
							</div>

							<div class="upload-box-bottom">
								<a href="../../../static/集体安全承诺书.docx" download="集体安全承诺书模板.docx">Download template</a>
							</div>
						</div>
						<Upload
							class="upload-button"
							ref="img_ref"
							:action="$baseUrl + '/sys/accessory/uploadFile'"
							:on-success="successUploadSafe"
							:max-size="10240"
							name="uploadFile">
							Select
						</Upload>
					<span style="margin-left: 10px; line-height: 30px; text-align: left;">(Please upload JPEG, PNG file)</span>
					</Col>
					<!-- <Col span="12" class="upload-block">
						<div style="width: 150px;">
							Health certificate：
						</div>
						<div class="upload-box">
							<div class="upload-box-top" :style="{backgroundColor: tuanduiObj.teamHealthyLetter ? '#FFFFFF' : '#D3D3D3'}">
								<img style="width: 100%; height: 100%;" v-if="tuanduiObj.teamHealthyLetter" :src="$imgUrl + tuanduiObj.teamHealthyLetter" alt="">
							</div>

							<div class="upload-box-bottom">
								<a href="../../../static/健康证明.docx" download="健康证明模板.docx">Download template</a>
							</div>
						</div>
						<Upload
							class="upload-button"
							ref="img_ref"
							:action="$baseUrl + '/sys/accessory/uploadFile'"
							:on-success="successUploadTeamHealthyLetter"
							:max-size="10240"
							name="uploadFile">
							Select
						</Upload>
						<span style="margin-left: 10px; line-height: 30px; text-align: left;">(Please upload JPEG, PNG file)</span>
					</Col> -->
				</Row>
				<Row style="margin-top: 20px;">
					Fill in the membership list
				</Row>
<!-- 				<div class="upload-user">
					<div style="font-size: 12px; color: #686868;">
						导入团员名单：
					</div>

					<Upload
						style="background-color: #196EE8; color: #FFFFFF; font-size: 11px; margin-left: 20px; height: 30px; width: 100px; line-height: 30px; margin-top: 5px; cursor: pointer;"
						ref="excel_ref"
						:action="$baseUrl + '/api/ticket/importTeam'"
						:on-success="successUpload"
						:max-size="10240"
						name="file">
						选择文件
					</Upload>

					<div style="margin-left: 20px; font-size: 12px; color: #196EE8; cursor: pointer;">

						<a href="../../../static/user_info.xlsx" download="团队人员信息模板.xlsx">下载模板</a>
					</div>
				</div> -->
				<Row class="rymd-top">
					<Col span="2">
						Select
					</Col>
					<Col span="3">
						Ticket type
					</Col>
					<Col span="2">
						Name
					</Col>
					<Col span="3">
						ID Type
					</Col>
					<Col span="7">
						ID Number
					</Col>
					<Col span="7">
						Phone number
					</Col>
				</Row>
				<Row class="rymd-block" v-for="(item, index) in tuanduiObj.user_list" :key="index">
					<Col span="2">
						<Checkbox v-model="item.select"></Checkbox>
					</Col>
					<Col span="3">
						Group booking
					</Col>
					<Col span="2">
						<Input v-model="item.name" style="width: 80%; margin: 0 10%;"></Input>
					</Col>
					<Col span="3">
						<Select v-model="item.card_type">
							<Option v-for="item1 in zjType" :value="item1.value" :key="item1.value">{{ item1.label }}</Option>
						</Select>
					</Col>
					<Col span="7">
						<Input v-model="item.card_no" style="width: 80%; margin: 0 10%;"></Input>
					</Col>
					<Col span="7">
						<Input v-model="item.mobile" style="width: 80%; margin: 0 10%;"></Input>
					</Col>
				</Row>
				<div class="bottom-button">
					<div class="add-one" @click="tdAddOne">
						Add
					</div>
					<div class="rm-check" @click="deleteUserList">
						Clear selected visitors
					</div>
				</div>
				<div class="commit-button" @click="commitTd">
					Booking the ticket
				</div>
			</div>
		</div>
		<div class="step3" v-if="step === 3">
			<div v-if="yuYueType === 'geren'">
				<div class="geren-top">
					<div class="qrcode">
						<img :src="orderObj.qrCode" alt="">
					</div>
					<div style="text-align: left;">
						<div style="color: #686868; font-size: 22px;">
							Your have successfully reserved the ticket for {{orderObj.date}}
						</div>
						<div style="margin-top: 5px;  color: #686868;">
							Order No：{{orderObj.order_num}}, {{orderObj.num}} person in total
						</div>
						<div style="margin-top: 5px; color: #FC4850; font-size: 12px;">
							<p>
								Please take a screenshot or photo of this page and save it.
							</p>
							<p>
								Then go to the west side of the main gate to enter the security check.
							</p>
							<p>
								Please visit the museum at the appointed time.
							</p>
							<p>
								No admission for those who advance or miss the booking time.
							</p>
						</div>
					</div>
				</div>
				<div style="text-align: left; width: 700px; margin: 10px auto; font-size: 18px;">
					<div>
						1. There is no parking service in the museum, and green travel is advocated.
					</div>
					<div>
						2. Please take good care of the elderly and children during your visit to the museum to prevent collisions and accidents.
					</div>
					<div>
						3. Please prepare your valid certificate, make an appointment with QR code and green health code in advance, and cooperate with the staff for routine security check.
					</div>
					<div>
						4. Other matters not covered herein shall be subject to the information on the official website, APP and official account of the Navy Museum.
					</div>
				</div>

				<div style="text-align: left; width: 700px; margin: 10px auto;">
					<div style="margin-top: 20px; color: #686868; font-size: 14px;">
						Admission stops at 16:00 and closes at 17:00.
					</div>
					<div style="margin-top: 2px; color: #686868; font-size: 14px;">
						Visitors who fill in the second-generation ID card can enter the museum directly with the original id card.
					</div>
					<div style="margin-top: 2px; color: #686868; font-size: 14px;">
						Visitors who fill in Hong Kong, Macao and Taiwan ID cards or passports should bring the original id cards to the ticket window to exchange for tickets, and then enter the museum with the tickets.
					</div>
				</div>

				<div class="bottom">
					<div style="margin-right: 50px; cursor: pointer;" @click="toMpyy">
						View order
					</div>
					<div style="cursor: pointer;" @click="backStep1">
						Continue to buy tickets
					</div>
				</div>
			</div>
			<div v-else>
				<!-- <div class="geren-top"> -->
				<div class="qrcode">
					<img src="../../../static/dsh.png" alt="">
				</div>
				<div style="text-align: center;">
					<div style="color: #686868; font-size: 22px;">
						To be reviewed
					</div>
					<div style="font-size: 16px; font-weight: 500;">
						Your have successfully reserved the ticket for {{orderObj.date}}
					</div>
					<!-- <div style="margin-top: 5px;  color: #686868; font-size: 16px; font-weight: 500;">
						Order No：{{orderObj.order_num}}
					</div> -->
					<div style="margin-top: 5px;  color: #686868; font-size: 16px; font-weight: 500;">
						Team name：{{orderObj.orgName}}, {{orderObj.num}}  person in total
					</div>
					<div style="margin-top: 10px; color: #686868; font-size: 16px; font-weight: 500;">
						Contact name: {{orderObj.liaisonUser}}, Contact mobile number: {{orderObj.liaisonPhone}}
					</div>
					<div style="margin-top: 5px; color: #FC4850; font-size: 12px;">
						<p>
							Please take a screenshot or photo of this page and save it.
						</p>
						<p>
							Then go to the west side of the main gate to enter the security check.
						</p>
						<p>
							Please visit the museum at the appointed time.
						</p>
						<p>
							No admission for those who advance or miss the booking time.
						</p>
					</div>
				</div>
				<div style="text-align: left; width: 700px; margin: 10px auto;">
					<div style="margin-top: 20px; color: #686868; font-size: 14px;">
						Admission stops at 16:00 and closes at 17:00.
					</div>
					<div style="margin-top: 2px; color: #686868; font-size: 14px;">
						Visitors who fill in the second-generation ID card can enter the museum directly with the original id card.
					</div>
					<div style="margin-top: 2px; color: #686868; font-size: 14px;">
						Visitors who fill in Hong Kong, Macao and Taiwan ID cards or passports should bring the original id cards to the ticket window to exchange for tickets, and then enter the museum with the tickets.
					</div>
				</div>

				<div class="bottom">
					<div style="margin-right: 50px; cursor: pointer;" @click="toMpyy">
						View order
					</div>
					<div style="cursor: pointer;" @click="backStep1">
						Continue to buy tickets
					</div>
				</div>
			</div>
		</div>
		<Modal
			v-model="showConfirm"
			@on-ok="sureCommit"
			:mask-closable="false"
			:closable="false"
			@on-cancel="showConfirm = false"
			ok-text="Confirm"
			cancel-text="Cancel">
			<div slot="header" style="height: 45px; line-height: 45px; text-align: center; font-size: 12px; padding: 0;">
				Warm prompt
			</div>
			<div style="display: flex; margin: 20px; height: 30px; line-height: 30px;">
				<Icon type="ios-alert-outline" size="30" color="#127EBD"/>
				<p style="margin-left: 20px;">Please confirm whether to submit the order?</p>
			</div>
		</Modal>
		<Modal v-model="showTdConfirm" :mask-closable="false" width="1000" footer-hide :scrollable="true">
			<div slot="header" style="background-color: #1173E1; color: #FFFFFF; height: 45px; line-height: 45px; text-align: center; font-size: 12px; padding: 0;">
				The order information
			</div>
			<div style="margin: 20px;">
				<p>
					Please confirm your order information
				</p>
				<p>
					Team name：{{tuanduiObj.teamname}}
				</p>
				<p v-if="ticketList.length > 0">
					Time in the library：Group booking {{chooseDate.allDate}} {{ticketList[mpType].timeInterval}}
				</p>
				<p>
					Leader：{{tuanduiObj.name}}   <span style="margin-left: 15px;">Leader's mobile number：{{tuanduiObj.telephone}}</span>
				</p>
			</div>
			<Row class="rymd-top">
				<Col span="4">
					Ticket type
				</Col>
				<Col span="3">
					Name
				</Col>
				<Col span="3">
					ID Type
				</Col>
				<Col span="7">
					ID Number
				</Col>
<!-- 				<Col span="2">
					性别
				</Col>
				<Col span="3">
					出生年
				</Col>
				<Col span="2">
					国籍
				</Col> -->
				<Col span="7">
					Mobile number
				</Col>
			</Row>
			<Row class="rymd-block" v-for="(item, index) in selectList" :key="index">
				<Col span="4">
					Group booking
				</Col>
				<Col span="3">
					{{item.name}}
				</Col>
				<Col span="3">
					<span v-for="item1 in zjType" :key="item1.value" v-if="item1.value == item.card_type">
						{{item1.label}}
					</span>
				</Col>
				<Col span="7">
					{{item.card_no}}
				</Col>
<!-- 				<Col span="2">
					{{item.gander}}

				</Col>
				<Col span="3">
					{{item.year}}
				</Col>
				<Col span="2">
					{{item.country}}
				</Col> -->
				<Col span="7">
					{{item.mobile}}
				</Col>
			</Row>
			<div class="modal-bottom">
				<div>
					<Checkbox v-model="isRead"></Checkbox>
					<span>I have read and agree to the booking instructions</span>
				</div>
				<div class="right" @click="sureTdCommit">
					Submit
				</div>
			</div>
		</Modal>

		<Modal v-model="showNeedRead" :mask-closable="false" width="1000" footer-hide :scrollable="true" class="need-read-modal">
			<div slot="header" style="background-color: #1173E1; color: #FFFFFF; height: 45px; line-height: 45px; text-align: center; font-size: 12px; padding: 0;">
				{{yuYueType == 'geren' ? "The PLA Navy Museum personal booking instructions" : "The PLA Navy Museum team booking instructions"}}
			</div>
			<div slot="close">
				<Icon type="ios-close" style="color: #FFF; font-size: 30px; margin-right: 20px; font-weight: bold;"/>
			</div>
			<Scroll style="margin-top: 20px; padding: 0 40px;" height="600">
				<div v-html="yuYueType === 'geren' ? needReadGr : needReadTd" >

				</div>
			</Scroll>

			<div style="margin-top: 20px; text-align: center;">
				<Checkbox v-model="isAgree"></Checkbox>I have read and agree to the above booking instructions
			</div>
			<div style="margin: 20px 0; padding-bottom: 20px;">

				<div @click="sureReadNext" style="width: 80px; height: 40px; text-align: center; color: #FFFFFF; cursor: pointer; margin: 0 auto; line-height: 40px;" :style="{background: isAgree ? '#1173E1' : 'rgba(0, 0, 0, 0.2)'}">
					Next
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				step: 1,
				month: '',
				chooseIndex: 0,
				dateList: [

				],
				tdDateList: [

				],
				yuYueType: 'geren',
				chooseDate: {
					date: '',

				},
				ticketList: [],
				telephone: '',
				liaisonUser: '',
				yearType: [
					{
						name: "",
						key: "VISIT_TICKET"
					}
					// ,
					// {
					// 	name: "亲子票",
					// 	key: "PARENT_CHILD_TICKET"
					// }
				],
				zjType: [
					{
						label: 'ID Card',
						value: 'ID_CARD'
					},
					{
						label: 'Passport',
						value: 'PASSPORT'
					},
					{
						label: 'Taiwan Card',
						value: 'TAIWAN_CARD'
					},
					{
						label: 'Green Card',
						value: 'GREEN_CARD'
					},
					{
						label: 'Hk Macao Tai Card',
						value: 'HK_M_T_CARD'
					}
				],
				sexType: [
					{
						value: "男",
						label: "男"
					},
					{
						value: "女",
						label: "女"
					}
				],
				selfUserList: [
					{
						ticket_type: 'VISIT_TICKET',
						card_type: 'ID_CARD',
						card_no: "",
						name: ""
					}
				],
				showConfirm: false,
				orderObj: {},
				tuanduiObj: {
					name: '',
					telephone: '',
					teamname: '',
					letter: '',
					teamOrderLetter: '',
					teamVisitLetter: '',
					// teamHealthyLetter: '',
					user_list: []
				},
				selectList: [],
				showTdConfirm: false,
				isRead: false,
				needReadGr: "",
				needReadTd: "",
				mpType: 0,
				showTable: false,
				showNeedRead: false,
				isAgree: false,
				loadingBotton: false,
				statusObj: {
					"未参观": "To be visited",
					"已参观": "Visited",
					"已取消": "Cancelled",
					"待审核": "To be audit",
					"审核不通过": "Audit failed",
					"过期未入馆": "Overdue"
				},
				imgData: '',
				validateCode: ""
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
			that.getDataList()
			that.getTdDateList()
			that.getXz()
			this.getImgData()
			var jump_type = that.$route.query.jump_type
			if(jump_type == 'edit') {
				that.step = 2
				that.yuYueType = 'tuandui'

				var ticket_details = JSON.parse(that.$http.getStorage('ticket'))
				that.tuanduiObj = {
					name: ticket_details.liaisonUser,
					telephone: ticket_details.liaisonPhone,
					teamname: ticket_details.userOrg.orgName,
					letter: ticket_details.letter,
					teamOrderLetter: ticket_details.teamOrderLetter,
					teamVisitLetter: ticket_details.teamVisitLetter,
					// teamHealthyLetter: ticket_details.teamHealthyLetter,
					user_list: []
				}
				that.chooseDate = {
					allDate: ticket_details.visitDate
				}
				that.getTicketData()
				ticket_details.ticketVisits.forEach(item => {
					that.tuanduiObj.user_list.push({
						select: true,
						name: item.name,
						card_type: 'ID_CARD',
						card_no: item.idCard,
						mobile: item.mobile
					})
				})
				that.$forceUpdate()
				console.log(that.tuanduiObj, that.chooseDate);
			}
		},
		methods: {
			getImgData() {
				let that = this
				let url = '/api/user/ck/getImageValidateCode'
				that.$http.post({
					url: url,
					data: {}
				}).then(res => {
					if(res.code === 'S200') {
						that.imgData = "data:image/png;base64," + res.data.code
					} else {
						that.$Message.error(res.msg)
					}
				})
			},
			getXz() {
				let that = this
				that.$http.post({
					url: '/api/channel/findContentListByChannelId',
					data: {
						channelId: 52,
						releaseTerrace: "releasePc"
					}
				}).then(res => {
					if(res.code === 'S200') {
						res.data.forEach(item => {
							if(item.title.indexOf('Team') > -1) {
								that.needReadTd = item.txt
							} else {
								that.needReadGr = item.txt
							}
						})
					}
				})
			},
			tdAddOne() {
				this.tuanduiObj.user_list.push({
					select: true,
					name: '',
					card_type: 'ID_CARD',
					card_no: '',
					mobile: ''
				})
			},
			successUpload(res, file) {
				let that = this
				if(res.code === 'S200') {
					that.tuanduiObj.user_list = []
					res.data.forEach(item => {
						that.tuanduiObj.user_list.push({
							select: true,
							name: item.name,
							card_type: 'ID_CARD',
							card_no: item.idCard,
							// gander: item.sex,
							// year: item.birthY,
							// country: item.nationality,
							mobile: item.mobile
						})
					})
					that.$forceUpdate()
				} else {
					that.$Message.error(res.msg)
				}
			},
			successUploadSafe(res, file) {
				let that = this
				if(res.code === 'S200') {
					that.tuanduiObj.letter = res.data.id
					that.$forceUpdate()
				}
			},
			successUploadTeamOrderLetter(res, file) {
				let that = this
				if(res.code === 'S200') {
					that.tuanduiObj.teamOrderLetter = res.data.id
					that.$forceUpdate()
				}
			},
			successUploadTeamVisitLetter(res, file) {
				let that = this
				if(res.code === 'S200') {
					that.tuanduiObj.teamVisitLetter = res.data.id
					that.$forceUpdate()
				}
			},
			successUploadTeamHealthyLetter(res, file) {
				let that = this
				if(res.code === 'S200') {
					// that.tuanduiObj.teamHealthyLetter = res.data.id
					that.$forceUpdate()
				}
			},
			deleteUserList() {
				var dataList = this.tuanduiObj.user_list
				this.tuanduiObj.user_list = []
				dataList.forEach(item => {
					if(!item.select) {
						this.tuanduiObj.user_list.push(item)
					}
				})
			},
			getDataList() {
				let that = this
				that.dateList = []
				that.month = that.$moment().format('YYYY-MM')
				var today_week = Number(that.$moment().format('d'))
				if(today_week == 0) {
					for(var i=0; i<14;i++){
						that.dateList.push({
							date: that.$moment().add(i, 'days').format('MM-DD'),
							allDate: that.$moment().add(i, 'days').format('YYYY-MM-DD'),
							is_show: true,
							week: that.$moment().add(i, 'days').format('d')
						})
					}
				} else {
					for(var i = -today_week; i < 0; i++){
						that.dateList.push({
							date: that.$moment().add(i, 'days').format('MM-DD'),
							allDate: that.$moment().add(i, 'days').format('YYYY-MM-DD'),
							is_show: false,
							week: that.$moment().add(i, 'days').format('d')
						})
					}
					for(var i=0; i < 14 - today_week ; i++){
						that.dateList.push({
							date: that.$moment().add(i, 'days').format('MM-DD'),
							allDate: that.$moment().add(i, 'days').format('YYYY-MM-DD'),
							is_show: true,
							week: that.$moment().add(i, 'days').format('d')
						})
					}
				}
				that.getTicketList()
			},
			getTdDateList() {
				let that = this
				that.$http.post({
					url: '/api/ticket/getNextWeekTicket',
					data: {}
				}).then(res => {
					if(res.code === 'S200') {
						that.tdDateList = []
						var dateList = res.data
						var firstWeek = 0
						var endWeek = 6
						if(dateList.length > 0) {
							firstWeek = Number(that.$moment(dateList[0].date).format('d'))
							endWeek = Number(that.$moment(dateList[dateList.length - 1].date).format('d'))
						}
						if(firstWeek == 0) {
							dateList.forEach(item => {
								that.tdDateList.push({
									date: that.$moment(item.date).format('MM-DD'),
									allDate: that.$moment(item.date).format('YYYY-MM-DD'),
									is_show: true,
									week: that.$moment(item.date).format('d'),
									open: item.open,
									left_tickets_num: item.left_team_num
								})
							})
						} else {
							for(var i = -firstWeek; i < 0; i++){
								that.tdDateList.push({
									is_show: false
								})
							}
							dateList.forEach(item => {
								that.tdDateList.push({
									date: that.$moment(item.date).format('MM-DD'),
									allDate: that.$moment(item.date).format('YYYY-MM-DD'),
									is_show: true,
									week: that.$moment(item.date).format('d'),
									open: item.open,
									left_tickets_num: item.left_team_num
								})
							})
						}
						if(endWeek < 6) {
							for(var i = endWeek; i < 6; i++){
								that.tdDateList.push({
									is_show: false
								})
							}
						}
						console.log(that.tdDateList);
						that.$forceUpdate()
					}
				})
			},
			getTicketList() {
				let that = this
				that.$http.post({
					url: '/api/en/ticket/getTicDateNum/',
					data: {}
				}).then(res => {
					if(res.code === 'S200') {
						res.data.forEach(item => {
							that.dateList.some((it, index) => {
								if(it.allDate === item.date) {
									that.dateList[index].open = item.open
									that.dateList[index].left_tickets_num = item.left_tickets_num
									return
								}
							})
						})
						that.$forceUpdate()
					}
				})
			},
			selectDate(date) {
				if(!date.is_show || !date.open) {
					return
				}
				if(date.left_tickets_num == 0) {
					this.$Message.error('No tickets available on that day, please make reservations for other dates.')
					return
				}
				var url = '/api/en/ticket/ck/checkAppointmentAuthority'
				var data = {
					orderType: "TEAM"
				}
				if(this.yuYueType == 'geren') {
					data.orderType = 'PERSONAL'
				}
				if (this.yuYueType == 'geren') {
					this.$http.post({
						url: '/api/ticket/checkTicketConf',
						data: {
							code: 'TICKETDEADLINE'
						}
					}).then(res => {
						if(res.code === "S200") {
							let nowTime = new Date().getTime()
							let day = this.$moment(new Date()).format('YYYY-MM-DD')
							let time = day + ' ' + res.data[0].vals + ':59'
							let configTime = new Date(time).getTime()
							console.log(time)
							if (nowTime > configTime) {
								this.$Message.error('Cannot make an appointment at the current time. Please make an appointment before ' + res.data[0].vals)
								return
							} else {
								this.$http.post({
									url: url,
									data: data
								}).then(res => {
									if(res.code == 'S200') {
										this.chooseDate.date = date.date
										this.chooseDate.allDate = date.allDate
										this.showNeedRead = true
									} else {
										this.$Message.error(res.msg)
									}
								})
							}
						}
					})
				} else {
					this.$http.post({
						url: url,
						data: data
					}).then(res => {
						if(res.code == 'S200') {
							this.chooseDate.date = date.date
							this.chooseDate.allDate = date.allDate
							this.showNeedRead = true
						} else {
							this.$Message.error(res.msgEn)
						}
					})
				}
			},
			sureReadNext() {
				if(!this.isAgree) {
					return
				}
				this.showNeedRead = false
				this.step = 2
				this.getTicketData()
			},
			getTicketData() {
				let that = this
				that.$http.post({
					url: '/api/en/ticket/ck/checkIsLogin',
					data: {

					}
				}).then(res => {
					if(res.code === 'S200') {

					} else {
						return
					}
				})
				that.$http.post({
					url: '/api/en/ticket/getTicTimeNum',
					data: {
						visitDate: that.chooseDate.allDate
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.ticketList = res.data
					} else {
						that.$Message.error(res.msg)
						that.ticketList = []
					}
				})
			},
			addSelf() {
				if(this.selfUserList.length >= 5) {
					this.$Message.info('A maximum of five tickets can be reserved at one time.')
					return
				}
				this.selfUserList.push({
					ticket_type: 'VISIT_TICKET',
					card_type: 'ID_CARD',
					card_no: "",
					name: ""
				})
			},
			removeSelf(index) {
				this.selfUserList.splice(index, 1)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			downExcel() {
				require.ensure([], () => {
					const { export_json_to_excel } = require('./vendor/Export2Excel');
					const tHeader = [ '姓名', '身份证号', '性别', '出生年', '国籍'];
					const filterVal = ['name', 'idCard', 'sex', 'year', 'country']
					const list = [{
						name: "示例(DEMO)",
						idCard: "37XXXXXXXXXXXXXXXX",
						sex: "男",
						year: "1950",
						country: "中国"
					}]
					const data = this.formatJson(filterVal, list)
					export_json_to_excel(tHeader, data, '团队人员信息模板');
				})
			},
			backStep1() {
				this.selfUserList = [
					{
						ticket_type: 'VISIT_TICKET',
						card_type: 'ID_CARD',
						card_no: "",
						name: ""
					}
				]
				this.chooseDate = {
					date: '',
					tickets: 0,
					allDate: '',
					morning: 0,
					afternoon: 0
				}
				this.mpType = 0
				this.telephone = ""
				this.liaisonUser = ""
				this.isAgree = false
				this.step = 1
				this.getDataList()
				this.getTdDateList()
			},
			commitSelf() {
				let that = this
				var canSend = true
				if(!that.telephone || !that.liaisonUser) {
					that.$Message.error("Please enter the contact information.")
					return
				}
				if(that.telephone.length != 11) {
					that.$Message.error('Please enter the correct mobile phone number.')
					return
				}
				if (!that.validateCode) {
					that.$Message.error('Please enter the verification code.')
					return
				}
				that.selfUserList.forEach(item => {
					if(!item.card_no || !item.name) {
						that.$Message.error("Please improve the order user information.")
						canSend = false
						return
					}
				})
				if(canSend) {
					that.showConfirm = true
				}
			},
			commitTd() {
				let that = this
				if(!that.tuanduiObj.teamname) {
					that.$Message.error('Please enter a team name')
					return
				}
				if(!that.tuanduiObj.telephone) {
					that.$Message.error("Please enter the leader's mobile phone number")
					return
				}
				if(that.tuanduiObj.telephone.length != 11) {
					that.$Message.error('Please enter the correct mobile phone number')
					return
				}
				if(!that.tuanduiObj.name) {
					that.$Message.error("Please enter the leader's name")
					return
				}
				if(!that.tuanduiObj.letter) {
					that.$Message.error('Please upload the security commitment letter')
					return
				}
				if(!that.tuanduiObj.teamOrderLetter) {
					that.$Message.error('Please upload the group visit reservation form')
					return
				}
				if(!that.tuanduiObj.teamVisitLetter) {
					that.$Message.error('Please upload the group visit letter')
					return
				}
				// if(!that.tuanduiObj.teamHealthyLetter) {
				// 	that.$Message.error('Please upload your health certificate')
				// 	return
				// }
				that.selectList = []
				that.isRead = false
				var canCommit = true
				that.tuanduiObj.user_list.forEach(item => {
					if(item.select) {
						that.selectList.push(item)
						if(!item.name || !item.card_no) {
							canCommit = false
						}
					}
				})
				if(!canCommit) {
					that.$Message.error('Please complete all user information')
					return
				}
				if(that.selectList.length < 20 || that.selectList.length > 100) {
					that.$Message.error('The group size should be more than 20 (including 20 people) and less than 100 (including 100 people)')
					return
				}

				that.showTdConfirm = true
			},
			sureCommit() {
				let that = this
				if(that.loadingBotton) {
					return
				}
				that.loadingBotton = true
				var data = {}
				console.log(that.ticketList[that.mpType]);
				data.ticket = {
					liaisonPhone: that.telephone,
					liaisonUser: that.liaisonUser,
					visitDate: that.chooseDate.allDate,
					visitTime: that.ticketList[that.mpType].timeInterval,
					orderType: "PERSONAL"
				}
				data.list = []
				that.selfUserList.forEach(item => {
					data.list.push({
						name: item.name,
						idCard: item.card_no,
						ticketType: item.ticket_type,
						mobile: "",
						certificateType: item.card_type
					})
				})
				data.validateCode = that.validateCode
				that.$http.post({
					url: '/api/en/ticket/ck/addTicket',
					data: data
				}).then(res => {
					if(res.code === 'S200') {
						console.log(res.data);
						that.orderObj = {
							date: res.data.visitDate,
							num: res.data.total,
							order_num: res.data.partnerOrderId
						}
						that.getOrder(res.data.partnerCode)
						that.selfUserList = [
							{
								ticket_type: 'VISIT_TICKET',
								card_type: 'ID_CARD',
								card_no: "",
								name: ""
							}
						]
						that.chooseDate = {
							date: '',
							tickets: 0,
							allDate: '',
							morning: 0,
							afternoon: 0
						}
						that.mpType = 0
						that.telephone = ""
					} else {
						that.$Message.error(res.msg)
					}
					that.loadingBotton = false
				})
			},
			getOrder(partnerCode) {
				let that = this
				that.$http.post({
					url: '/api/en/ticket/ck/createQRCode?partnerCode=' + partnerCode,
					data: {}
				}).then(res => {
					if(res.code === 'S200') {
						that.orderObj.qrCode = res.data
						that.step = 3
					} else {
						that.$Message.error(res.msg)
					}
				})
			},
			sureTdCommit() {
				let that = this
				if(!that.isRead) {
					that.$Message.error('Please read the instructions first')
					return
				}
				if(that.loadingBotton) {
					return
				}
				that.loadingBotton = true
				var data = {}

				data.ticket = {
					liaisonPhone: that.tuanduiObj.telephone,
					liaisonUser: that.tuanduiObj.name,
					visitDate: that.chooseDate.allDate,
					visitTime: that.ticketList[that.mpType].timeInterval,
					orderType: "TEAM",
					letter: that.tuanduiObj.letter,
					teamOrderLetter: that.tuanduiObj.teamOrderLetter,
					teamVisitLetter: that.tuanduiObj.teamVisitLetter,
					// teamHealthyLetter: that.tuanduiObj.teamHealthyLetter,
					orgName: that.tuanduiObj.teamname
				}
				data.list = []
				that.selectList.forEach(item => {
					data.list.push({
						name: item.name,
						idCard: item.card_no,
						ticketType: "ADULT_TICKET",
						mobile: item.mobile,
						certificateType: item.card_type
					})
				})

				that.$http.post({
					url: '/api/en/ticket/ck/addTicket',
					data: data
				}).then(res => {
					if(res.code === 'S200') {
						console.log(res.data);
						that.orderObj = {
							date: res.data.visitDate,
							num: res.data.total,
							order_num: res.data.partnerOrderId,
							liaisonUser: res.data.liaisonUser,
							liaisonPhone: res.data.liaisonPhone
						}
						if(res.data.orgName) {
							that.orderObj.orgName = res.data.orgName
						}
						that.getOrder(res.data.partnerCode)
						that.mpType = 0
						that.tuanduiObj = {
							name: '',
							telephone: '',
							teamname: '',
							jieshaoxin: '',
							zerenshu: '',
							ming_dan_file: '',
							user_list: [],
						}
						that.step = 3
					} else {
						that.$Message.error(res.msg)
					}
					that.loadingBotton = false
					that.showTdConfirm = false
				})
			},
			toMpyy() {
				this.$router.push('wdmpyy')
			}
		}
	}
</script>

<style lang="less" scoped>
	.rymd-top {
		height: 40px;
		line-height: 40px;
		background-color: #1173E1;
		color: #FFFFFF;
		font-size: 12px;
		margin-top: 20px;
		text-align: center;
	}
	.rymd-block {
		height: 50px;
		line-height: 50px;
		font-size: 12px;
		border-bottom: 1px solid #808080;
		text-align: center;
	}
	.modal-bottom {
		margin: 30px 20px 0;
		display: flex;
		justify-content: space-between;
		height: 40px;
		line-height: 40px;
		font-size: 12px;
		color: #686868;
		padding-bottom: 50px;
		.right {
			width: 80px;
			height: 40px;
			background-color: #1173E1;
			text-align: center;
			color: #FFFFFF;
			cursor: pointer;
		}
	}
	.step-block {
		width: 30%;
		margin: 120px 35% 0;
		display: flex;
		justify-content: space-between;
		height: 70px;
		.step-box {
			font-size: 9px;
			color: #077DBA;
			.step-img {
				width: 20px;
				height: 20px;
				margin: 5px auto;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		.step-line {
			height: 33px;
			width: 20%;
		}
	}
	.step1 {
		width: 70%;
		margin: 0 15% 20px;
		.top {
			height: 30px;
			width: 100%;
			border-bottom: 1px solid #077DBA;
			.top-choose {
				width: 40%;
				margin: 0 30%;
				display: flex;
				justify-content: space-between;
				text-align: center;
				// .choose {
				// 	width: 45%;
				// 	font-size: 13px;
				// 	cursor: pointer;
				// 	height: 30px;
				// }
				.choose {
					width: 100%;
					font-size: 13px;
					cursor: pointer;
					height: 30px;
				}
			}
		}
		.choose-1 {
			margin: 15px 0 60px;
			.month {
				background-color: #666666;
				color: #FFFFFF;
				font-size: 13px;
				height: 30px;
				line-height: 30px;
				width: 15%;
				margin: 0 auto;
			}
			.calendar {
				width: 84%;
				margin: 20px 8%;
				.calendar-top {
					display: flex;
					justify-content: space-between;
					.calendar-top-box {
						width: 13%;
						height: 25px;
						line-height: 25px;
						text-align: center;
						background-color: #264EA7;
						color: #FFFFFF;
						font-size: 14px;
						display: flex;
						justify-content: space-between;
						padding: 0 5px;
					}
				}
				.calendar-main {
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					.calendar-box {
						width: 13%;
						height: 60px;
						border: 1px solid #E4E4E4;
						margin-top: 10px;
						cursor: pointer;
						.close-date {
							color: #aaa;
							.close-date-left {
								font-size: 20px;
								text-align: center;
								height: 35px;
								line-height: 35px;
								font-weight: 400;
							}
							.close-date-right {
								font-size: 14px;
								height: 20px;
								line-height: 20px;
								text-align: center;
							}
						}
						.open-date {
							color: #264EA7;
							.open-date-top {
								font-size: 20px;
								text-align: center;
								height: 35px;
								line-height: 35px;
								font-weight: 400;
							}
							.open-date-bottom {
								font-size: 14px;
								height: 20px;
								line-height: 20px;
								text-align: center;
							}
						}
					}
				}

			}
			.yuyue-type {
				height: 40px;
				width: 100%;
				display: flex;
				justify-content: center;
				.yuyue-box {
					width: 180px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					margin: 0 20px;
					font-size: 13px;
					cursor: pointer;
				}
			}
		}
	}
	.step2 {
		width: 74%;
		margin: 20px 13% 50px;
		.geren-block {
			width: 100%;
			.geren-date {
				text-align: left;
				font-size: 12px;
			}
			.mp-type {
				display: flex;
				justify-content: left;
				height: 40px;
				margin-top: 20px;
			}
			.telephone-top {
				height: 40px;
				width: 100%;
				line-height: 40px;
				background-color: #196EE8;
				color: #FFFFFF;
				font-size: 13px;
				text-align: left;
				padding: 0 50px;
			}
			.telephone-bottom {
				height: 50px;
				width: 100%;
				line-height: 50px;
				font-size: 13px;
				text-align: left;
				padding: 0 30px;
				border-bottom: 1px solid #196EE8;
			}
			.self-user-list-top {
				margin-top: 50px;
				height: 40px;
				line-height: 40px;
				background-color: #196EE8;
				color: #FFFFFF;
				font-size: 13px;
				text-align: left;
				display: flex;
			}
			.self-user-item {
				height: 50px;
				line-height: 50px;
				font-size: 13px;
				text-align: left;
				border-bottom: 1px solid #196EE8;
			}
			.tishi {
				margin-top: 30px;
				display: flex;
				font-size: 12px;
			}
			.button-list {
				margin-top: 30px;
				text-align: right;
				width: 90%;
			}
		}
		.tuandui-block {
			width: 100%;
			.tuandui-date {
				text-align: left;
				font-size: 12px;
			}
			.mp-type {
				display: flex;
				justify-content: left;
				height: 40px;
				margin-top: 20px;
			}
			.block {
				height: 40px;
				width: 100%;
				line-height: 40px;
				background-color: #196EE8;
				color: #FFFFFF;
				font-size: 13px;
				text-align: left;
				padding: 0 50px;
				margin-top: 20px;
			}
			.tdzl-block {
				height: 70px;
				line-height: 70px;
				color: #686868;
			}
			.upload-block {
				display: flex;
				margin-top: 30px;
				.upload-text {
					font-size: 12px;
					color: #686868;
					margin-left: 20px;
				}
				.upload-box {
					margin-left: 15px;
					.upload-box-top {
						width: 110px;
						height: 150px;
						background: #D3D3D3;
					}
					.upload-box-bottom {
						text-align: center;
						margin-top: 10px;
						color: #1059BF;
						font-size: 12px;
						cursor: pointer;
					}
				}
				.upload-button {
					margin-left: 20px;
					width: 100px;
					height: 30px;
					line-height: 30px;
					text-align: center;
					background-color: #196EE8;
					color: #FFFFFF;
					cursor: pointer;
				}
			}
			.upload-user {
				display: flex;
				margin-top: 20px;
				height: 40px;
				line-height: 40px;
			}
			.bottom-button {
				width: 600px;
				display: flex;
				justify-content: space-between;
				margin: 30px auto;
				.add-one {
					width: 200px;
					border: 1px solid #1059BF;
					height: 40px;
					line-height: 40px;
					font-size: 16px;
					color: #1059BF;
					cursor: pointer;
				}
				.rm-check {
					width: 200px;
					border: 1px dashed #1059BF;
					height: 40px;
					line-height: 40px;
					font-size: 16px;
					color: #1059BF;
					cursor: pointer;
				}
			}
			.commit-button {
				width: 10%;
				margin: 30px 0 0 90%;
				text-align: center;
				height: 40px;
				line-height: 40px;
				font-size: 12px;
				background-color: #1173E1;
				color: #FFFFFF;
				cursor: pointer;
			}
		}
	}
	.step3 {
		margin-top: 30px;
		text-align: center;
		.geren-top {
			width: 600px;
			display: flex;
			margin: 0 auto;
			justify-content: center;
			.qrcode {
				width: 150px;
				height: 150px;
				margin-right: 20px;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.bottom {
			margin: 20px 0 100px;
			display: flex;
			justify-content: center;
			color: #264EA7;
			font-size: 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/reservation/ticket_booking.vue